/* eslint-disable react/no-did-update-set-state */
import React, { Component } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { toPng } from "html-to-image"

import DownloadIcon from "../../../assets/images/download_icon.png"

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 120px;
`

const ButtonRow = styled.div`
  position: relative;
  width: 100%;
`

const GenerateImageButton = styled.button`
  position: relative;
  width: 40px;
  height: 40px;
  display: block;
  right: 0;
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 8px 8px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: 0.15s transform ease;
  padding: 8px;
`

const Icon = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
`

const DesignerTray = styled.div`
  position: relative;
  height: 800px;
  width: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${({ trayImagePath }) => trayImagePath});
  background-repeat: no-repeat;
  background-size: cover;
`

const DesignerMask = styled.div`
  align-items: center;
  border-radius: ${({ mask }) => mask.borderRadius}px;
  box-shadow: 8px 8px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  height: ${({ mask }) => mask.height}px;
  justify-content: center;
  position: relative;
  width: ${({ mask }) => mask.width}px;
  overflow: hidden;
`

const Image = styled.img`
  position: absolute;
  width: ${({ image }) => image.width}px;
  height: ${({ image }) => image.height}px;
  top: ${({ image }) => image.top}px;
  left: ${({ image }) => image.left}px;
  transform: ${({ image }) => `rotate(${image.rotateAngle}deg)`};
`

const Result = styled.img`
  position: relative;
  width: 800px;
  height: 800px;
`

class GenerateImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      imageSrc: null,
      isLoading: false,
    }

    this.canvasRef = React.createRef()

    this.generateImage = () => this.setState(({
      imageSrc: null,
      isLoading: true,
    }), () => {
      if (this.canvasRef) {
        toPng(this.canvasRef.current).then((dataUrl) => {
          // const link = document.createElement("a")
          // link.download = "personalized-tray.png"
          // link.href = dataUrl
          // link.click()

          this.setState({
            imageSrc: dataUrl,
            isLoading: false,
          })
        })
      }
    })
  }

  componentDidUpdate(prevProps) {
    const { thumbnail } = this.props

    // clear thumbnail
    if (prevProps.thumbnail && !thumbnail) {
      this.setState({ imageSrc: null })
    }
  }

  render() {
    const { imageSrc, isLoading } = this.state

    const {
      mask,
      trayImagePath,
      imageInfo,
      thumbnail,
    } = this.props

    return (
      <Wrapper>
        <ButtonRow>
          <GenerateImageButton onClick={this.generateImage}>
            <Icon src={DownloadIcon} />
          </GenerateImageButton>
        </ButtonRow>

        {isLoading === true && (
          <DesignerTray ref={this.canvasRef} trayImagePath={trayImagePath}>
            <DesignerMask mask={mask}>
              {thumbnail && (
                <Image image={imageInfo} src={thumbnail} />
              )}
            </DesignerMask>
          </DesignerTray>
        )}

        {imageSrc && (<Result src={imageSrc} alt="result" />)}
      </Wrapper>
    )
  }
}

GenerateImage.propTypes = {
  trayImagePath: PropTypes.string.isRequired,
  mask: PropTypes.object.isRequired,
  imageInfo: PropTypes.object.isRequired,
  thumbnail: PropTypes.string,
}

GenerateImage.defaultProps = {
  thumbnail: null,
}

export default GenerateImage
